/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Calendar_Scope_Online_OnlyInputs */



/**
* | output |
* | --- |
* | "online only" |
*
* @param {Tournaments_Calendar_Scope_Online_OnlyInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_calendar_scope_online_only = /** @type {((inputs?: Tournaments_Calendar_Scope_Online_OnlyInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Calendar_Scope_Online_OnlyInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("en ligne uniquement")
	if (locale === "es") return /** @type {LocalizedString} */ ("solo en línea")
	if (locale === "pt") return /** @type {LocalizedString} */ ("apenas online")
	if (locale === "it") return /** @type {LocalizedString} */ ("solo online")
	return /** @type {LocalizedString} */ ("online only")
});